import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table"
import {
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { TableDataProps } from "@/types/types"

export const TableHeaderComponent = <TableRowType,>({
  data,
  columns
}: TableDataProps<TableRowType>
) => {

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <TableHeader className="bg-border">
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableHead
              key={header.id}
              className="truncate max-w-[150px] overflow-hidden text-ellipsis !font-semibold"
              title={typeof header.column.columnDef.header === "string"
                ? header.column.columnDef.header
                : undefined
              }
            >
              {header.isPlaceholder
                ? null
                : flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
            </TableHead>
          ))}
        </TableRow>
      ))}
    </TableHeader>
  )
}
